import React, { useEffect, useState } from 'react';
import { Text } from './Text';
import { Button } from './Button';
import { TextInput } from './TextInput';
import { DatePicker } from 'antd';
/**
 * Base component to create forms.
 * The form can be customized using the customForm prop.
 *
 *
 * @param headerForm: the header of the form
 * @param displayMapping: the mapping of the fields to be displayed
 * @param data: the data to be displayed in the form
 * @param onCreate: the function to be called when creating a new entity
 * @param onUpdate: the function to be called when updating an entity
 * @param onTest: the function to be called when testing the entity created
 * @param isLoading: if the form is loading
 * @param isEditingForm: if the form is in editing mode
 * @param usePlaceholders: if the form should use placeholders instead of labels
 * @returns
 */
export const FormView = ({ headerForm, data, displayMapping, onCreate, onUpdate, onTest, isLoading = false, isEditingForm = false, usePlaceholders = false, style, customForm, }) => {
    const [isEditing, setIsEditing] = useState(isEditingForm);
    const [entity, setEntity] = useState(data || {});
    useEffect(() => {
        setIsEditing(isEditingForm);
    }, [isEditingForm]);
    useEffect(() => {
        setEntity(data);
    }, [data]);
    const onSave = () => {
        const fieldsToUpdate = Object.keys(displayMapping).reduce((acc, key) => {
            if (entity.hasOwnProperty(key)) {
                acc[key] = entity[key];
            }
            return acc;
        }, {});
        onUpdate(entity.id, fieldsToUpdate);
        setIsEditing(false);
    };
    return (React.createElement("div", null,
        headerForm && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "flex-row", style: { justifyContent: 'space-between' } },
                React.createElement(Text, { value: headerForm, className: "header2" }),
                React.createElement("div", { className: "flex-row", style: { gap: 12, maxHeight: 32 } }, isEditing ? (React.createElement(React.Fragment, null,
                    React.createElement(Button, { text: 'Cancel', onClick: () => setIsEditing(false) }),
                    React.createElement(Button, { text: 'Save', onClick: onSave, isLoading: isLoading }))) : entity && onUpdate ? (React.createElement(React.Fragment, null,
                    React.createElement(Button, { text: 'Edit', isLoading: isLoading, onClick: () => setIsEditing(true) }),
                    onTest && React.createElement(Button, { text: 'Test', isLoading: isLoading, onClick: () => onTest(entity.id) }))) : onCreate && !isLoading ? (React.createElement(Button, { text: 'Create', onClick: () => onCreate(entity) })) : null)),
            React.createElement("hr", { style: { color: 'grey', height: 1, width: '100%', padding: 0, margin: 2 } }))),
        customForm ? (React.createElement("div", { className: "flex-column", style: { gap: 16, paddingTop: 16, textAlign: 'left', ...style } }, React.cloneElement(customForm, { entity, isEditing, setEntity, onSave, style }))) : entity ? (React.createElement("div", { className: "flex-column", style: { gap: 16, paddingTop: 16, textAlign: 'left', ...style } }, Object.keys(displayMapping).map((key, index) => {
            const label = displayMapping[key];
            const value = entity[key];
            return (React.createElement("div", { key: index, className: !usePlaceholders && 'flex-row', style: { gap: 12 } },
                !usePlaceholders && (React.createElement(Text, { style: { alignSelf: 'center', width: 200, fontWeight: 700 }, value: `${label}:` })),
                typeof value === 'string' ? (!isEditing ? (React.createElement(Text, { value: value })) : (React.createElement(TextInput, { value: value, placeholder: usePlaceholders ? `Enter ${label}` : '', setText: (text) => setEntity((entity) => ({
                        ...entity,
                        [key]: text,
                    })), style: { maxWidth: 512 } }))) : typeof value === 'number' ? (React.createElement(Text, { value: value.toFixed(2) })) : value instanceof Date ? (React.createElement(DatePicker, { value: value, onChange: (date) => setEntity((entity) => ({
                        ...entity,
                        [key]: date,
                    })) })) : Array.isArray(value) ? (React.createElement(React.Fragment, null)) : null));
        }))) : null));
};
